export default __webpack_public_path__ + "static/media/Jet.853077ab.svg";